import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "nav",
  class: "nav-shell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNavbar = _resolveComponent("AppNavbar")!
  const _component_AppSidenav = _resolveComponent("AppSidenav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppNavbar),
    _createVNode(_component_AppSidenav, { id: "sidenav" })
  ]))
}